import {
  LOAD_VEHICLE_HONEYTOASTPLAYBACK,
} from "./actions";

const initialState = {
  vehicleLists: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VEHICLE_HONEYTOASTPLAYBACK.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
      };
    default:
      return state;
  }
};
